import get from 'lodash.get'
import i18n from '../i18n'

export const STATES = {
  default: i18n.t('strings.default'),
  awaiting_approval: i18n.t('strings.awaitingApproval'),
  lacking_input: i18n.t('strings.lackingInput'),
  cancelled: i18n.t('strings.cancelled'),
  booked: i18n.t('strings.booked'),
  production_in_progress: i18n.t('strings.productionInProgress'),
  waiting_for_input: i18n.t('strings.waitingForInput'),
  delivered: i18n.t('strings.delivered'),
  partially_delivered: i18n.t('strings.partiallyDelivered'),
  ordered: i18n.t('strings.ordered'),
  marked_for_correction: i18n.t('strings.markedForCorrection'),

  // Product specific overrides
  VideoProduct: {
    lacking_input: i18n.t('strings.videoProduct.lackingInput'),
  },
  CollageProduct: {
    lacking_input: i18n.t('strings.collageProduct.lackingInput'),
  },
  RetouchedEveningPhotoProduct: {
    lacking_input: i18n.t('strings.retouchedEveningPhotoProduct.lackingInput'),
  },
  DigitalRetouchedFurnishingPhotoProduct: {
    lacking_input: i18n.t('strings.digitalRetouchedFurnishingPhotoProduct.lackingInput'),
  },
  DigitalRetouchedRenovationPhotoProduct: {
    lacking_input: i18n.t('strings.digitalRetouchedRenovationPhotoProduct.lackingInput'),
  },
  DigitalRetouchedPeoplePhotoProduct: {
    lacking_input: i18n.t('strings.digitalRetouchedPeoplePhotoProduct.lackingInput'),
  },
  SlideshowProduct: {
    lacking_input: i18n.t('strings.slideshowProduct.lackingInput'),
  }
}

export function translateProductState(product) {
  let state = product.state

  if (product.canProvideUserInput) {
    state = 'lacking_input'
  }

  const productSpecificPath = product.__typename
    ? `${product.__typename}.${state}`
    : state

  return get(STATES, productSpecificPath) || STATES[state] || STATES.default
}
